var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.value.salaryStatements
      ? _c(
          "div",
          _vm._l(_vm.value.salaryStatements, function (salaryStatement, i) {
            return _c(
              "div",
              { key: i, staticClass: "salary-statement-fields" },
              _vm._l(salaryStatement, function (glossValues, gloss) {
                return _c(
                  "div",
                  { key: gloss.name, staticClass: "salary-statement-field" },
                  [
                    _c("div", { staticClass: "inputs-title" }, [
                      _c("div", { staticClass: "inputs-title-text" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "title-text is-size-6 has-text-weight-semibold",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.salaryStatementGlosses[gloss].title)
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "title-comment is-size-7" }, [
                          _vm._v(
                            _vm._s(_vm.salaryStatementGlosses[gloss].comment)
                          ),
                        ]),
                      ]),
                      _c("a", {
                        staticClass: "fa fa-plus-circle",
                        attrs: {
                          id: `${_vm.debtorIndex}-add-${_vm.salaryStatementGlosses[gloss].id}`,
                          href: "#",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("add-input", {
                              debtorIndex: _vm.debtorIndex,
                              type: "income",
                              gloss,
                            })
                          },
                        },
                      }),
                    ]),
                    _vm._l(glossValues, function (glossValue, j) {
                      return _c(
                        "div",
                        {
                          key: `${i}-${gloss}-${j}`,
                          staticClass: "gloss-value",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                id: `debt-${i}-${gloss}-${j}-delete-button`,
                                href: "#",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.$emit("delete-input", {
                                    debtorIndex: _vm.debtorIndex,
                                    type: "income",
                                    incomeType: "salaryStatements",
                                    incomeIndex: i,
                                    gloss,
                                    inputIndex: j,
                                  })
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa-solid fa-trash-can" })]
                          ),
                          _c(
                            "div",
                            { staticClass: "b-field-inputs" },
                            _vm._l(
                              _vm.salaryStatementGlosses[gloss].glossFields,
                              function (field, fieldName) {
                                return _c(
                                  "div",
                                  {
                                    key: `${i}-${gloss}-${j}-${fieldName}`,
                                    staticClass: "b-field-input",
                                  },
                                  [
                                    field.jsonType === "array"
                                      ? _c(
                                          "div",
                                          { staticClass: "b-field-inputs" },
                                          _vm._l(field.quantity, function (k) {
                                            return _c("BaseInput", {
                                              key: k,
                                              staticClass: "b-field-input",
                                              attrs: {
                                                id: `${_vm.debtorIndex}-${i}-${gloss}-${j}-${fieldName}-${k}`,
                                                value:
                                                  _vm.value.salaryStatements[i][
                                                    gloss
                                                  ][j][fieldName][k - 1],
                                                type: field.type,
                                                "format-type": field.formatType,
                                                title: `${field.title} ${k}`,
                                                placeholder: field.placeholder,
                                                icon: field.icon,
                                              },
                                              on: {
                                                input: (value) =>
                                                  _vm.updateInputs(
                                                    value,
                                                    i,
                                                    gloss,
                                                    j,
                                                    fieldName,
                                                    k - 1
                                                  ),
                                              },
                                            })
                                          }),
                                          1
                                        )
                                      : _c(
                                          "div",
                                          [
                                            _c("BaseInput", {
                                              attrs: {
                                                id: `${_vm.debtorIndex}-${i}-${gloss}-${j}-${fieldName}`,
                                                value:
                                                  _vm.value.salaryStatements[i][
                                                    gloss
                                                  ][j][fieldName],
                                                type: field.type,
                                                "format-type": field.formatType,
                                                title: field.title,
                                                placeholder: field.placeholder,
                                                icon: field.icon,
                                              },
                                              on: {
                                                input: (newValue) =>
                                                  _vm.updateInputs(
                                                    newValue,
                                                    i,
                                                    gloss,
                                                    j,
                                                    fieldName,
                                                    null
                                                  ),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }